import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export const taskDetailGridColumns = (rows) => columnDefs(rows);

function columnDefs(rows) {

    let tempColumnDefs = [];

    rows.map((object) => {
        Object
            .keys(object)
            .map((key) => {
                const mappedColumn = {
                    headerName: key,
                    field: key,
                };
                tempColumnDefs.push(mappedColumn);
            });
    });

    tempColumnDefs = tempColumnDefs.filter((column, index, self) =>
        index === self.findIndex((colAtIndex) => (
            colAtIndex.field === column.field)));

    const columnDefs = [];
    const durationVF = ({ value }) => apiProvider.formatDuration({ seconds: value });

    for (const each of tempColumnDefs) {
        if (each.headerName !== 'id' && each.headerName !== 'Actual Cost' && each.headerName !== 'Forecast Cost') {
            let hide = false;
            let valueFormatter = null;
            let width = null;
            let suppressColumnsToolPanel = false
            let suppressFiltersToolPanel = false
            if (each.headerName === 'Duration' || each.headerName === 'Time Spent') {
                valueFormatter = durationVF;
            }
            if (each.headerName === 'k' || each.headerName === 'vid' || each.headerName === 'id') {
                hide = true;
                suppressColumnsToolPanel = true;
                suppressFiltersToolPanel = true;
            }
                columnDefs.push({
                    headerName: each.headerName,
                    field: each.field,
                    hide,
                    valueFormatter,
                    pivot: false,
                    suppressColumnsToolPanel,
                    suppressFiltersToolPanel
                });
        }
    }
    return columnDefs;
}
